import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  FETCH_TWILIO_CONVERSATIONS,
  PUSH_TWILIO_CONVERSATION,
} from '../actions';
import {
  fetchTwilioConversationsSuccess,
  pushTwilioConversationsSuccess,
} from './actions';
import { AxiosAPI, getUserID } from '../../helpers/AxiosAPI';
import { Client as ConversationsClient } from '@twilio/conversations';
const TWILIO_TOKEN_GEN_URL = process.env.REACT_APP_CHAT_API + '/twilio-token';
const fetchConversationsAPI = async () => {
  try {
    const identityBody = { identity: getUserID() };
    const tokenResp = await fetch(TWILIO_TOKEN_GEN_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(identityBody),
    });

    if (!tokenResp.ok) {
      const text = await tokenResp.text().catch(() => '');
      throw new Error(
        `Failed to fetch Twilio token: ${tokenResp.status} ${text}`
      );
    }

    const twilioToken = await tokenResp.json();
    const accessToken = twilioToken.accessToken;
    if (!accessToken)
      throw new Error('No accessToken returned from Twilio token endpoint');

    const conversationsClient = await ConversationsClient.create(accessToken);
    const conversations = (
      await conversationsClient.getSubscribedConversations()
    ).items;
    return conversations; // return the conversations object (or .items if you prefer)
  } catch (err) {
    console.error('fetchConversationsAPI error:', err);
    throw err;
  }
};

function* fetchConversations() {
  try {
    const conversations = yield call(fetchConversationsAPI);
    console.log('saga conversations', conversations);
    yield put(fetchTwilioConversationsSuccess(conversations));
  } catch (error) {
    console.error('Error fetching Twilio conversations:', error);
    //yield put(fetchServiceFailure(error.message));
  }
}

function* pushTwilioConversations({ payload }) {
  console.log('saga push conversation', payload);
  yield put(pushTwilioConversationsSuccess(payload.twilioChatId));
}

export function* watchFetchTwilioConversations() {
  yield takeEvery(FETCH_TWILIO_CONVERSATIONS, fetchConversations);
  yield takeEvery(PUSH_TWILIO_CONVERSATION, pushTwilioConversations);
}

export default function* twilioConversationsSaga() {
  yield all([fork(watchFetchTwilioConversations)]);
}
